<div class="container-margin">
  <h2>{{ translationService.getReportsText() }}</h2>
  <div class="actions margin-top-10">
    <a [routerLink]="['/admin/reports/fpr']" class="action-item">
      <button
        type="button"
        mat-raised-button
        extended
        color="accent"
        class="action-button"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getAddReportText() }}
      </button>
    </a>
  </div>
  <div class="margin-top-20">
    <app-reports-list></app-reports-list>
  </div>
</div>
